import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Hexagon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/95 backdrop-blur-md py-4 shadow-lg' : 'bg-navy-900 py-6'}`} data-id="element-93">
      <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between" data-id="element-94">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-95">
          <div className="relative flex items-center justify-center w-8 h-8" data-id="element-96">
            <Hexagon className="absolute w-full h-full text-white stroke-[1.5]" data-id="element-97" />
            <div className="w-2 h-2 bg-white rounded-sm rotate-45 group-hover:rotate-90 transition-transform duration-500" data-id="element-98"></div>
          </div>
          <span className="font-heading font-bold text-xl text-white tracking-wide" data-id="element-99">
            Portalplay<span className="text-navy-400" data-id="element-100">.</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-101">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-102">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-white text-navy-900 px-5 py-2.5 text-sm font-semibold hover:bg-slate-100 transition-colors flex items-center gap-2" data-id="element-103">
            Book a Strategy Call
            <div className="w-1.5 h-1.5 bg-navy-900 rounded-full" data-id="element-104"></div>
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-105">
          {isMobileMenuOpen ? <X size={24} data-id="element-106" /> : <Menu size={24} data-id="element-107" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 right-0 bg-navy-900 border-t border-navy-800 p-6 md:hidden shadow-xl" data-id="element-108">
          <div className="flex flex-col gap-4" data-id="element-109">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-slate-300 hover:text-white transition-colors py-2 border-b border-navy-800" onClick={() => setIsMobileMenuOpen(false)} data-id="element-110">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-white text-navy-900 px-5 py-3 text-center font-semibold mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-111">
              Book a Strategy Call
            </a>
          </div>
        </motion.div>}
    </header>;
}